import React from 'react';

import Loading from 'src/components/core/Loading';
import {SessionContext} from 'src/state/usePayinSessionContext';
import {V1Provider} from '@stripe-internal/data-v1';
import {useResumePayinSession} from 'src/api/useResumePayinSession';
import {UserFacingError} from 'src/utils/error';

import {useIntl} from 'react-intl';
import messages from 'src/utils/messages';

export const PayinSessionContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const resumePayinSessionResult = useResumePayinSession();
  const {data, error, status, loading} = resumePayinSessionResult;
  const intl = useIntl();

  if (error) {
    throw error;
  }

  if (status) {
    if (status !== 200) {
      switch (status) {
        case 404:
          throw new UserFacingError(intl.formatMessage(messages.error404));
        case 410:
          throw new UserFacingError(intl.formatMessage(messages.error410));
        default:
          throw new Error(`Unexpected status: ${status}`);
      }
    }
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <SessionContext.Provider value={data as SessionContext}>
      <V1Provider apiKey={(data as SessionContext).publishableKey}>
        {children}
      </V1Provider>
    </SessionContext.Provider>
  );
};
